const tagType = {
    warning: 'w5-tag-element--warning',
    success: 'w5-tag-element--success',
    info: 'w5-tag-element--info',
    ongoing: 'w5-tag-element--ongoing',
    error: 'w5-tag-element--error',
    pending: 'w5-tag-element--pending',
};

export default function Tag({ value, styles, type }) {
    if (!value) return;

    const tag = document.createElement('div');
    tag.classList.add('w5-tag-element');
    if (type && tagType[type]) tag.classList.add(tagType[type]);
    if (styles?.container) {
        Object.keys(styles.container).forEach((current) => {
            tag.style[current] = styles.container[current];
        });
    }

    const content = document.createElement('div');
    content.classList.add('w5-tag-element__content');
    if (styles?.content) {
        Object.keys(styles.content).forEach((current) => {
            content.style[current] = styles.content[current];
        });
    }
    content.innerText = value;
    tag.appendChild(content);

    return tag;
}
